import React, { useContext, useEffect } from "react"
import { userContext } from '../../stores/users/userContext';
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";


const Logout = () => {
    const userStore = useContext(userContext);
    const navigate = useNavigate();

    useEffect(() => {
        userStore.logoutBackEnd();
        navigate('/landing/')
    }, [])
    return null
}

export default observer(Logout)